import { useI18n, useSwitchLocalePath } from '#i18n'
import { useRouter } from 'vue-router'
import * as veev from 'vee-validate'
import * as veevI18n from '@vee-validate/i18n'

import fr from '@vee-validate/i18n/dist/locale/fr.json'
import en from '@vee-validate/i18n/dist/locale/en.json'
import es from '@vee-validate/i18n/dist/locale/es.json'
export function useLanguages() {
  const { locale } = useI18n()
  const switchLocalePath = useSwitchLocalePath()
  const router = useRouter()

  veevI18n.setLocale(locale.value)

  veev.configure({
    generateMessage: veevI18n.localize({
      fr,
      en,
      es
    })
  })

  const changeLocale = (newLocale) => {
    veevI18n.setLocale(newLocale)
    router.push(switchLocalePath(newLocale))
  }

  return {
    changeLocale
  }
}
